<side-panel
  [headerInfo]="{ title: this.selectedKpiByKey ? this.selectedKpiByKey.kpi.name : '--' }"
  [expanded]="sidePanelExpanded"
  (closed)="onSidePanelClosed()"
  (expandedClicked)="onExpandedPanelOpened()"
>
  <ng-container side-content *ngIf="!notAllowedError; else notAllowed">
    <page-header [title]="pageTitle"></page-header>
    <loading-wheel
      *ngIf="isLoading; else loadedDataBlock"
      class="study-details-loading-wheel"
    ></loading-wheel>
    <ng-template #loadedDataBlock>
      <div class="centered-page-container">
        <div
          class="study-details-container"
          [ngClass]="{
            'collapsed-app-content': sidebarCollapsed,
            'expanded-app-content': !sidebarCollapsed,
            'with-side-panel': sidePanelExpanded
          }"
        >
          <breadcrumb [protocolNumber]="protocolNumber"></breadcrumb>
          <ai-summary-variants
            *featureFlag="'enableStudyInsightsVariants'"
            [milestones]="
              studyMilestonesRes.status === 'success' ? studyMilestonesRes.data : undefined
            "
            [kpis]="allKpisByCategory"
            (termClicked)="onTermClicked($event)"
          ></ai-summary-variants>
          <ai-summary
            *featureFlag="'enableStudyInsights'"
            [summary]="studySummary"
            [summaryMaxWidth]="'700px'"
            [collapsedHeight]="'140px'"
            [expandable]="true"
            (termClicked)="onTermClicked($event)"
          ></ai-summary>
          <study-gantt-chart
            *ngIf="studyMilestonesRes"
            [studyMilestonesRes]="studyMilestonesRes"
            (expandedStagesChange)="onExpandedStagesChange($event)"
          ></study-gantt-chart>
          <kpis
            [kpisByCategory]="filteredKpisByCategory ?? allKpisByCategory"
            [expandedGanttChartStages]="expandedGanttChartStages"
            [keyMilestones]="keyMilestones"
          ></kpis>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #notAllowed>
    <error-view [type]="'not-allowed'"></error-view>
  </ng-template>

  <kpi-charts-side-panel
    side-panel-body
    *ngIf="allKpisByCategory && studyMilestonesRes"
    [kpiConfig]="kpiConfig"
    [kpisByCategory]="allKpisByCategory"
    [milestoneStages]="
      studyMilestonesRes.status === 'success' ? studyMilestonesRes.data.stages : []
    "
    [studySk]="studySk"
    [protocolNumber]="protocolNumber ?? ''"
    [selectedKpiByKey]="selectedKpiByKey"
  ></kpi-charts-side-panel>
</side-panel>
